<template>
  <div class="divEditMain">
    <div class="divAction">
      <h3 class="pTopBarL">{{ p_title }}</h3>
      <p v-if="!bbPrint" class="pTopBarR">
        <button v-for="btn in p_btns" :key="btn.act" @click="toAct(btn.act)"><!--  v-if="btn.act>0"-->
          <!--{{ btn.act }};-->{{ btn.name }}
        </button>
        <button @click="toDo(17)">关闭</button>
      </p>
    </div><!--按钮-->
    <div class="divEdit">
      <div>
        <div
          v-for="(mm,idx) in p_colm"
          :key="idx"
          class="editTdDiv">
          <p class="editTdDivL">
            {{ mm.label }}：
          </p>
          <p class="editTdDivR">
            {{ p_row[mm.value] }}
          </p>
        </div>
      </div><!--头-->
      <div v-if="p_colm_entry.length>0" :style="[{height:(bbPrint?allHeight:editHeight)+'px'}]" class="divEditEntry"><!-- :style="[{width:p_width+30+'px'}]"-->
        <table style="width:98%;" class="editTb"><!-- :style="[{width:p_width+'px'}]"-->
          <thead>
            <tr class="editTbHead">
              <th/>
              <th v-for="(row,idx) in p_colm_entry" :key="idx">{{ row.label }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row,idx) in p_entry" :key="idx">
              <td>{{ idx+1 }}</td>
              <td
                v-for="(mm,eidx) in p_colm_entry"
                :key="eidx"
                :class="mm.readonly?'tdRead':'tdEdit'"
                :style="[{'width':mm.vwidth+'%'}]">
                {{ row[mm.value] }}
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr class="editTbFoot">
              <th/>
              <th v-for="(row,idx) in p_colm_entry" :key="idx">{{ rowSum[row.value] }}</th>
            </tr>
          </tfoot>
        </table>
      </div><!--体-->
      <div class="divEdit3">
        <div
          v-for="(mm,idx) in p_colm"
          :key="idx"
          class="divRead">
          <b>{{ mm.label }}：</b>{{ p_row[mm.value] }}
        </div>
      </div><!--制单与审核-->
    </div><!--编辑区-->
    <p v-show="bbPrint" id="qrCode" class="divQRCode"/>
  </div>
</template>
<script type="text/javascript">
// import QRCode from 'qrcodejs2'
import '../../../static/c_editb.css'
export default{
  name: 'CPrint',
  components: {
  },
  props: {
    p_active: {
      type: Boolean,
      default: false
    },
    p_btns: {
      type: Array,
      default: () => {
        return []
      }
    },
    p_colm: {
      type: Array,
      default: () => {
        return []
      }
    },
    p_colm_entry: {
      type: Array,
      default: () => {
        return []
      }
    },
    p_row: {
      type: Object,
      default: () => {
        return {}
      }
    },
    p_entry: {
      type: Array,
      default: () => {
        return []
      }
    },
    p_title: {
      type: String,
      default: '欢迎使用'
    },
    p_url: {
      type: String,
      default: ''
    },
    p_width: {
      type: Number,
      default: 900
    },
    p_files: {
      type: Array,
      default: () => {
        return []
      }
    },
    toDo: {
      type: Function,
      default: null
    },
    a_save: {
      type: Function,
      default: null
    }
  },
  data: function() {
    return {
      bbPrint: false,
      idx: 0,
      editRow: {},
      editHeight: 0,
      allHeight: 0,
      editEntrys: [],
      rowSum: {}
    }
  },
  watch: {
    p_active: {
      handler(newV, oldV) {
        if (newV) this.mkEditor()
      },
      immediate: true// deep: true
    }
  },
  created() {
    // this.prt('created.编辑中的对象', this.p_row)
  },
  activated() {
    // this.mkQrImg()// this.prt('activated.编辑中的对象', this.p_row)
  },
  methods: {
    prt(a, b) {
      console.log(`c2_4_print.${a}`, b)
    },
    toChk_delt0831() {
      this.prt('toChk', this.p_btns)
    },
    toAct(iAct) {
      this.prt('toAct.' + iAct, this.editRow)
      if (iAct === 4) { // 审核
        this.editRow.iAct = iAct
        this.editRow.fstat = (this.editRow.fstat === 0 ? 1 : 0)
        this.toDo(1, this.editRow)
      } else if (iAct === 11) this.toDo(11)// 退货
      else if (iAct === 12) this.toDo(12)// 退货
      else if (iAct === 14 || iAct === 15) this.toProd(iAct)// 生产开工\完工
      else if (iAct === 19) {
        this.bbPrint = true
        this.toDo(19)
        setTimeout(() => {
          this.bbPrint = false
        }, 3000)
      } else if (iAct === 33) this.toDo(33)// 销售打印
      else if (iAct === 34) this.toDo(34)// 生产打印
    },
    toProd(iAct) {
      this.editRow.iAct = iAct
      this.toDo(1, this.editRow)
    },
    mkValues(vLike, cbAct, pType) {
      if (vLike && vLike !== '') {
        this.values = this.p_values.filter(row => this.itemFinder(row, vLike))
      } else {
        this.values = this.p_values
      }
    },
    mkQrImg() {

    },
    mkEditor() {
      if (this.p_active) {
        this.prt('mkEditor.p_active', this.p_active)
        setTimeout(() => {
          this.mkQrImg()
        }, 1000)
      }
      // ************以下是处理entry********** //
      this.editRow = this.p_row
      if (!this.p_colm_entry || this.p_colm_entry.length === 0) return
      const height = 25 * this.p_entry.length
      this.prt('mkEditor.height', height)
      this.allHeight = height + 120
      this.editHeight = (height > 350 ? 350 : height) + 80
      this.p_colm_entry.forEach(colm2 => {
        if (colm2.vvtype === '3') {
          this.p_entry.forEach(row => {
            row[colm2.value] = this.dtUtil.dtFmt(row[colm2.value], '--')
          })
        }
      })// 格式化数据
      this.editEntrys = this.p_entry// this.p_row.entrys
      this.mkSum()
    },
    mkSum() {
      let qtyAll = 0
      let amtAll = 0
      let amtTaxAll = 0
      this.editEntrys.forEach(row => {
        if (!row.fiditem) return
        qtyAll += parseFloat(row.fqty)
        amtAll += parseFloat(row.famount)
        if (row.famttax)amtTaxAll += parseFloat(row.famttax)
      })
      this.rowSum = {
        fqty: qtyAll,
        famount: amtAll.toFixed(2),
        famttax: amtTaxAll.toFixed(2)
      }
      this.prt('mkSum..', this.rowSum)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/comps/c2_info/04_view.vue